/**
 * Styled Components - Created by david on 03/04/18.
 */
import styled from 'styled-components'
import Drawer from 'antd/lib/drawer'

export const Container = styled.div`
  background-color: #222;
`

export const overStyle = {
  zIndex: 1000,
  border: '1px solid #c7c7c7',
}

export const DrawerStyled = styled(Drawer)`
  .ant-drawer-close {
    height: 40px;
    width: 40px;
    line-height: 40px;
    top: var(--spacing-32);
    right: var(--spacing-32);
    color: var(--neutral-body);
  }
  .anticon-close {
    font-size: 20px;
  }
  .ant-drawer-body {
    padding: var(--spacing-32);
    margin-top: 58px;
  }
  #directLinks {
    border-bottom: 1px solid var(--neutral-border-med);
    padding-block: 7px;
    margin-block: 7px;
    border-top: 1px solid var(--neutral-border-med);
  }
`

export const LinkLine = styled.div`
  color: var(--neutral-secondary);
  font-family: var(--font-barlow-semi-condensed);
  font-size: 18px;
  font-style: normal;
  line-height: 26px;
  text-transform: uppercase;
  padding-block: 10px;
  &[data-bold="true"] {
    font-weight: 800;
    color: var(--neutral-darkest);
  }
`

export const ButtonAction = styled.div`
  display: flex;
  height: var(--spacing-42);
  padding: 7px var(--spacing-16);
  justify-content: center;
  align-items: center;
  margin-bottom: var(--spacing-16);
  background: var(--neutral-darkest);
  color: var(--neutral-white);
  font-family: var(--font-barlow);
  font-size: 12px;
  letter-spacing: 1.12px;
  text-transform: uppercase;
  &.secondary {
    border: var(--border-regular) solid var(--neutral-muted);
    background: var(--neutral-white);
    color: var(--neutral-body);
  }
`
  


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MobileMenu/styledComponents.tsx